import ACL_RELATIONSHIPS from "acl-relationships";

// Permissions that gate the global sidebar's destinations.

export const CAMPAIGNS_ACLS = [
  ACL_RELATIONSHIPS.campaigns.read,
  ACL_RELATIONSHIPS.region.read,
];
export const ENTITIES_ACLS = [
  ACL_RELATIONSHIPS.user.read,
  ACL_RELATIONSHIPS.tag.read,
  ACL_RELATIONSHIPS.entity.read,
];
export const CONTACTS_ACLS = [
  ACL_RELATIONSHIPS.user.read,
  ACL_RELATIONSHIPS.tag.read,
  ACL_RELATIONSHIPS.contact.read,
  ACL_RELATIONSHIPS.contactCustomFields.read,
];
export const DATA_ACLS = [ACL_RELATIONSHIPS.dataJob.read];
export const CASES_ACLS = [ACL_RELATIONSHIPS.case.read];
export const REVENUE_OPPORTUNITIES_ACLS = [
  ACL_RELATIONSHIPS.revenueOpportunity.readTable,
];
export const MACHINES_ACLS = [ACL_RELATIONSHIPS.machine.read];
export const DIAL_SESSIONS_ACLS = [ACL_RELATIONSHIPS.dialSession.read];
export const CALL_DASHBOARD_ACLS = [ACL_RELATIONSHIPS.callDashboard.read];
export const AGENT_DASHBOARD_ACLS = [
  ACL_RELATIONSHIPS.dialSession.read,
  ACL_RELATIONSHIPS.callQueueNextContact.read,
  ACL_RELATIONSHIPS.callQueueAddContact.create,
  ACL_RELATIONSHIPS.disposition.read,
  ACL_RELATIONSHIPS.emailUrlForms.read,
  ACL_RELATIONSHIPS.twilioToken.read,
  ACL_RELATIONSHIPS.tag.read,
  ACL_RELATIONSHIPS.user.read,
  ACL_RELATIONSHIPS.campaignStatuses.read,
  ACL_RELATIONSHIPS.callQueueItemsWithAgentAssigned.read,
  ACL_RELATIONSHIPS.twilioDisposition.create,
  ACL_RELATIONSHIPS.twilioAddToCall.create,
  ACL_RELATIONSHIPS.twilioRemoveFromCall.create,
  ACL_RELATIONSHIPS.twilioUpdateParticipant.create,
];
export const CALLS_ACLS = [ACL_RELATIONSHIPS.campaignTargetCall.readTable];
export const SWOOGO_EVENTS_ACLS = [ACL_RELATIONSHIPS.swoogo.readEvents];
export const SWOOGO_REGISTRANTS_ACLS = [
  ACL_RELATIONSHIPS.swoogo.readRegistrants,
];
export const SWOOGO_SESSIONS_ACLS = [ACL_RELATIONSHIPS.swoogo.readSessions];
export const SWOOGO_ATTENDANCES_ACLS = [
  ACL_RELATIONSHIPS.swoogo.readAttendances,
];
